import { useMemo } from "react";
import { useConsultantRoute } from "@tecnobit-srl/consultancies-route-types-consultant/lazy";
import { useConsultantIndexRoute } from "@tecnobit-srl/consultancies-route-types-consultant-index/lazy";
import { useConsultancyRequestsIndexRoute } from "@tecnobit-srl/consultancies-route-types-consultancy-requests-index/lazy";
//#region src/index.ts
var useConsultanciesRouteTypes = () => {
	const consultantRoute = useConsultantRoute();
	const consultantIndexRoute = useConsultantIndexRoute();
	const consultancyRequestsIndexRoute = useConsultancyRequestsIndexRoute();
	return useMemo(() => ({
		...consultantRoute,
		...consultantIndexRoute,
		...consultancyRequestsIndexRoute
	}), [
		consultantRoute,
		consultantIndexRoute,
		consultancyRequestsIndexRoute
	]);
};
//#endregion
export { useConsultanciesRouteTypes };
